import React from "react";
import LearnMorePromoCard from "./LearnMorePromoCard";
import ContactPromoCard from "./ContactPromoCard";
import { MASTER_ACCESS_DASHBOARD_PATH } from "./navConfig";

/**
 * Learn-more + contact promos at the bottom of the open navbar (layout rules by route and viewport height).
 */
const NavbarBottomPromos = ({
  pathname,
  screenHeight,
  parentData,
  cityAccess,
}) => {
  const isMasterDashboard = pathname === MASTER_ACCESS_DASHBOARD_PATH;
  const nodes = [];

  if (isMasterDashboard) {
    if (parentData?.image_url) {
      nodes.push(
        <LearnMorePromoCard
          key="learn-parent-ma"
          imageUrl={parentData.image_url}
          contactLink={parentData.contact_link}
          isCollapsed={screenHeight < 595}
        />,
      );
    } else if (cityAccess && !parentData) {
      nodes.push(
        <LearnMorePromoCard
          key="learn-city-ma"
          imageUrl={cityAccess.image_url}
          contactLink={cityAccess.contact_link}
          isCollapsed={screenHeight < 795}
        />,
      );
    }
  } else {
    if (parentData?.image_url) {
      if (screenHeight > 850) {
        nodes.push(
          <LearnMorePromoCard
            key="learn-parent-std"
            imageUrl={parentData.image_url}
            contactLink={parentData.contact_link}
            isCollapsed={false}
          />,
        );
      } else if (screenHeight >= 500) {
        nodes.push(
          <LearnMorePromoCard
            key="learn-parent-std-collapsed"
            imageUrl={parentData.image_url}
            contactLink={parentData.contact_link}
            isCollapsed={true}
          />,
        );
      }
    } else if (cityAccess && !parentData) {
      if (screenHeight > 850) {
        nodes.push(
          <LearnMorePromoCard
            key="learn-city-std"
            imageUrl={cityAccess.image_url}
            contactLink={cityAccess.contact_link}
            isCollapsed={false}
          />,
        );
      } else if (screenHeight <= 850 && screenHeight >= 500) {
        nodes.push(
          <LearnMorePromoCard
            key="learn-city-std-collapsed"
            imageUrl={cityAccess.image_url}
            contactLink={cityAccess.contact_link}
            isCollapsed={true}
          />,
        );
      }
    }
  }

  if (isMasterDashboard) {
    nodes.push(
      <ContactPromoCard
        key="contact-ma"
        isCollapsed={screenHeight <= 681}
      />,
    );
  } else if (screenHeight > 700) {
    nodes.push(
      <ContactPromoCard
        key="contact-std-expanded"
        isCollapsed={false}
      />,
    );
  } else if (screenHeight >= 500) {
    nodes.push(
      <ContactPromoCard
        key="contact-std-collapsed"
        isCollapsed={true}
      />,
    );
  }

  return <>{nodes}</>;
};

export default NavbarBottomPromos;
